import { allowedPath, featureHidden } from '../views/master/permissions';

// UI capabilities mirror server restrictions; the API remains authoritative.
const STAFF_ROLES = ['Administrator', 'Agency', 'Finance', 'HR', 'Account Executive', 'Trainee'];
const OPERATIONS = STAFF_ROLES.filter(role => role !== 'Trainee');
export const STAFF_ACCESS = {
  dashboard: STAFF_ROLES,
  reports: STAFF_ROLES,
  salary: ['Administrator', 'Finance'],
  customers: OPERATIONS,
  talents: OPERATIONS,
  organizations: OPERATIONS,
  agencies: OPERATIONS,
  feedback: ['Administrator', 'HR', 'Account Executive', 'Agency'],
  tasks: ['Administrator', 'Finance', 'HR', 'Account Executive', 'Agency'],
  manual: OPERATIONS,
  'payroll-hub': ['Administrator', 'Finance'],
  devices: ['Administrator', 'Finance', 'HR'],
  users: ['Administrator'],
  'activity-log': ['Administrator'],
  'telegram-bot': ['Administrator', 'Finance', 'HR'],
  settings: OPERATIONS,
  integrations: OPERATIONS,
  account: OPERATIONS,
  'ai-integrations': OPERATIONS,
};
export const canAccessStaffPath = (role, path) => {
  const section = path.replace(/^\//, '').split('/')[0];
  return Boolean(STAFF_ACCESS[section]?.includes(role));
};
export const canManageStaffUsers = role => role === 'Administrator';
// Master-policy accounts are gated by their capabilities; otherwise the role table applies.
// Sections the role table does not list (newer pages) fall back to the capability policy.
// Mass Email is limited to these roles (the BE rejects every other role on POST /customer/massEmail), whatever the capability policy.
export const MASS_EMAIL_PATH = '/admin/mass-email';
export const MASS_EMAIL_ROLES = ['Administrator', 'Account Executive'];
export const canOpenStaffPath = (user, path) => {
  if (featureHidden(path, user?.capabilities)) return false;
  if (path === MASS_EMAIL_PATH || path.startsWith(`${MASS_EMAIL_PATH}/`)) {
    if (!MASS_EMAIL_ROLES.includes(user?.role)) return false;
    return user?.capabilities?.policy === 'master' ? allowedPath(path, user.capabilities) : true;
  }
  if (user?.role === 'HR' && (path === '/payroll-hub' || path.startsWith('/payroll-hub/'))) return false;
  if (user?.capabilities?.policy === 'master') return allowedPath(path, user.capabilities);
  const section = path.replace(/^\//, '').split('/')[0];
  if (section in STAFF_ACCESS) return canAccessStaffPath(user?.role, path);
  return allowedPath(path, user?.capabilities);
};
